import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface SalonInvoiceProfile {
  accountHolder: string;
  bankName: string;
  iban: string;
  bic: string;
  taxNumber: string;
  vatId?: string;
  invoicePrefix: string;
  defaultPaymentTermsDays: number;
  // E-Rechnung Absender-Overrides
  /** Firmen-/Salonname des Rechnungsstellers (ZUGFeRD Seller Name) */
  senderCompanyName?: string;
  senderStreet?: string;
  senderZip?: string;
  senderCity?: string;
  senderCountry?: string;
  senderEmail?: string;
  senderPhone?: string;
}

export const DEFAULT_SALON_PROFILE: SalonInvoiceProfile = {
  accountHolder: '',
  bankName: '',
  iban: '',
  bic: '',
  taxNumber: '',
  vatId: '',
  invoicePrefix: 'RE-',
  defaultPaymentTermsDays: 14,
  senderCountry: 'DE',
};

export async function fetchSalonInvoiceProfile(mandantId: string): Promise<SalonInvoiceProfile> {
  if (!mandantId) return DEFAULT_SALON_PROFILE;
  try {
    const docRef = doc(db, 'kalkulation_mandanten', mandantId, 'settings', 'pepapers_profile');
    const snap = await getDoc(docRef);
    if (snap.exists()) {
      const data = snap.data() as Partial<SalonInvoiceProfile> & { isSmallBusiness?: boolean };
      // Legacy-Feld isSmallBusiness ignorieren (MwSt kommt aus App-Store)
      const { isSmallBusiness: _ignored, ...rest } = data;
      return { ...DEFAULT_SALON_PROFILE, ...rest };
    }
  } catch (err) {
    console.error('Fehler beim Laden des Rechnungs-Profils:', err);
  }
  return DEFAULT_SALON_PROFILE;
}

export async function saveSalonInvoiceProfile(
  mandantId: string,
  profile: Partial<SalonInvoiceProfile>
): Promise<boolean> {
  if (!mandantId) return false;
  try {
    const docRef = doc(db, 'kalkulation_mandanten', mandantId, 'settings', 'pepapers_profile');
    const { isSmallBusiness: _ignored, ...safeProfile } = profile as Partial<SalonInvoiceProfile> & {
      isSmallBusiness?: boolean;
    };
    await setDoc(docRef, safeProfile, { merge: true });
    return true;
  } catch (err) {
    console.error('Fehler beim Speichern des Rechnungs-Profils:', err);
    return false;
  }
}
